import { Routes, Route, Navigate } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop.jsx'
import StorefrontLayout from './components/StorefrontLayout.jsx'
import ProtectedRoute from './components/admin/ProtectedRoute.jsx'
import Home from './pages/Home.jsx'
import Catalog from './pages/Catalog.jsx'
import LocalPickup from './pages/LocalPickup.jsx'
import About from './pages/About.jsx'
import AdminLogin from './pages/admin/AdminLogin.jsx'
import AdminLayout from './pages/admin/AdminLayout.jsx'
import AdminDashboard from './pages/admin/AdminDashboard.jsx'
import AdminOrders from './pages/admin/AdminOrders.jsx'
import AdminApplications from './pages/admin/AdminApplications.jsx'
import AdminVisitors from './pages/admin/AdminVisitors.jsx'
import AdminBlog from './pages/admin/AdminBlog.jsx'
import BlogPostForm from './pages/admin/BlogPostForm.jsx'
import AdminSubscribers from './pages/admin/AdminSubscribers.jsx'
import AdminAffiliates from './pages/admin/AdminAffiliates.jsx'
import AdminCampaigns from './pages/admin/AdminCampaigns.jsx'
import AdminAccounts from './pages/admin/AdminAccounts.jsx'
import AffiliateDashboard from './pages/affiliate/AffiliateDashboard.jsx'
import ResearchUseTerms from './pages/legal/ResearchUseTerms.jsx'
import CertificatesOfAnalysis from './pages/legal/CertificatesOfAnalysis.jsx'
import PrivacyPolicy from './pages/legal/PrivacyPolicy.jsx'
import TermsOfService from './pages/legal/TermsOfService.jsx'
import RefundPolicy from './pages/legal/RefundPolicy.jsx'
import Login from './pages/account/Login.jsx'
import Signup from './pages/account/Signup.jsx'
import Pending from './pages/account/Pending.jsx'
import Account from './pages/account/Account.jsx'
import OrderHistory from './pages/account/OrderHistory.jsx'
import ForgotPassword from './pages/account/ForgotPassword.jsx'
import ResetPassword from './pages/account/ResetPassword.jsx'
import Checkout from './pages/checkout/Checkout.jsx'
import FAQ from './pages/FAQ.jsx'
import Blog from './pages/blog/Blog.jsx'
import BlogPost from './pages/blog/BlogPost.jsx'
import COAs from './pages/COAs.jsx'

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Storefront (public) */}
        <Route element={<StorefrontLayout />}>
          <Route path="/" element={<Home />} />
          {/* Compliance gate (StorefrontLayout): every page except the legal
              pages and login/signup needs an admin-approved account. */}
          <Route path="/products" element={<Catalog />} />
          {/* Old slug → redirect so existing /catalog links still work */}
          <Route path="/catalog" element={<Navigate to="/products" replace />} />
          <Route path="/delivery" element={<LocalPickup />} />
          {/* Old slug → redirect so existing /local-pickup links still work */}
          <Route path="/local-pickup" element={<Navigate to="/delivery" replace />} />
          <Route path="/partner" element={<About />} />
          {/* Old slug → redirect so existing /about links still work */}
          <Route path="/about" element={<Navigate to="/partner" replace />} />
          <Route path="/research-use-terms" element={<ResearchUseTerms />} />
          <Route
            path="/certificates-of-analysis"
            element={<CertificatesOfAnalysis />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/coas" element={<COAs />} />
          <Route path="/checkout" element={<Checkout />} />

          {/* Customer accounts */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/account/pending" element={<Pending />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/orders"
            element={
              <ProtectedRoute>
                <OrderHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/affiliate/dashboard"
            element={
              <ProtectedRoute requireAffiliate>
                <AffiliateDashboard />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="visitors" element={<AdminVisitors />} />
          <Route path="blog" element={<AdminBlog />} />
          <Route path="blog/new" element={<BlogPostForm />} />
          <Route path="blog/:id" element={<BlogPostForm />} />
          <Route path="subscribers" element={<AdminSubscribers />} />
          <Route path="affiliates" element={<AdminAffiliates />} />
          <Route path="campaigns" element={<AdminCampaigns />} />
          <Route path="accounts" element={<AdminAccounts />} />
        </Route>
      </Routes>
    </>
  )
}
